// extracted by mini-css-extract-plugin
module.exports = {"container":"libs_container__3sEjS","imgBlock":"libs_imgBlock__6CPcn","img":"libs_img__AMbgx","title":"libs_title__-iD5j","desc":"libs_desc__cChlU"};